export const CHAT_APP_DEF_ID = '14517e1a-3ff0-af98-408e-2bd6953c36a2';
